import {
  styled,
  flexColumn,
  flexAlignCenter,
  Theme,
  Colors,
  flexRow,
} from '@unfold/theme';
import { NavLink } from 'react-router-dom';
import { Typography } from '@unfold/typography';
import { down } from 'styled-breakpoints';

export const UnfoldMenu = styled.div`
  ${flexColumn}
  flex: 1;
  position: relative;

  ${down('mobile')} {
    ${flexRow}
    justify-content: space-around;
  }
`;

export const UnfoldLink = styled(NavLink)`
  ${flexAlignCenter}
  height: 47px;
  padding: 20px 0 20px 50px;
  font-weight: 500;
  transition: opacity 0.3s ease-in-out;
  font-size: 14px;
  line-height: 17px;
  opacity: 0.28;
  text-decoration: none;

  ${down('mobile')} {
    padding: 0;
  }

  &:hover {
    opacity: 1;
  }

  & + a {
    margin-top: 20px;

    ${down('mobile')} {
      margin-top: 0px;
      margin-left: 19px;
    }
  }
`;

export const LinkLabel = styled(Typography)`
  font-weight: 500;
  ${down('mobile')} {
    display: none;
  }
`;

export const LinkIcon = styled.div`
  display: none;

  ${down('mobile')} {
    display: block;
  }
`;

export const ActiveLinkLine = styled.div`
  width: 2.5px;
  background-color: ${({ theme }): string =>
    theme.name === Theme.LIGHT ? Colors.BLACK : Colors.WHITE};
  height: 47px;
  position: absolute;
  border-radius: 10px;
  top: 0;
  right: 0;
  transition: top 0.3s ease-in-out;

  ${down('mobile')} {
    display: none;
  }
`;
